import { css as e, styled as t } from "styled-components";
//#region src/components/SegmentedTabs/SegmentedTabs.styled.ts
var n = {
	capsule: "64px",
	compact: "40px",
	bar: "100%",
	underline: "56px"
}, r = t.div`
    position: relative;
    display: ${({ $variant: e }) => e === "bar" ? "flex" : "inline-flex"};
    align-items: stretch;
    gap: ${({ theme: e, $variant: t }) => t === "underline" ? e.spacing(3) : "2px"};
    padding: ${({ $variant: e }) => e === "underline" ? 0 : "4px"};
    border-radius: ${({ theme: e }) => e.radii.full};
    background: ${({ theme: e, $variant: t }) => t === "bar" || t === "underline" ? "transparent" : e.colors.muted};
    height: ${({ $variant: e }) => n[e]};
    width: ${({ $variant: e }) => e === "bar" ? "100%" : "auto"};
    max-width: 100%;
    box-sizing: border-box;
`, i = e`
    top: auto;
    bottom: 0;
    height: 2px;
    border-radius: 1px;
    background: ${({ theme: e }) => e.colors.foreground};
    box-shadow: none;
`, a = t.div`
    position: absolute;
    top: 4px;
    bottom: 4px;
    left: 0;
    border-radius: ${({ theme: e }) => e.radii.full};
    background: ${({ theme: e }) => e.colors.card};
    box-shadow: ${({ theme: e }) => e.shadows.md};
    ${({ $variant: e }) => e === "underline" && i}
    opacity: ${({ $ready: e }) => e ? 1 : 0};
    transition:
        transform 320ms cubic-bezier(0.22, 1, 0.36, 1),
        width 320ms cubic-bezier(0.22, 1, 0.36, 1);
    pointer-events: none;

    @media (prefers-reduced-motion: reduce) {
        transition: none;
    }
`, o = t.button`
    position: relative;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme: e, $variant: t }) => t === "compact" || t === "underline" ? e.spacing(1) : "2px"};
    flex-direction: ${({ $variant: e }) => e === "compact" || e === "underline" ? "row" : "column"};
    flex: ${({ $variant: e }) => e === "bar" ? "1 1 0" : "0 0 auto"};
    min-width: ${({ $variant: e }) => e === "capsule" ? "96px" : "0"};
    padding: ${({ theme: e, $variant: t }) => t === "capsule" ? e.spacing(0, 2) : t === "bar" || t === "underline" ? e.spacing(0, 1) : e.spacing(0, 1.75)};
    margin: 0;
    border: 0;
    border-radius: ${({ theme: e }) => e.radii.full};
    background: transparent;
    color: ${({ theme: e, $selected: t }) => t ? e.colors.foreground : e.colors.mutedForeground};
    cursor: pointer;
    appearance: none;
    transition: color ${({ theme: e }) => e.transitions.fast};
    white-space: nowrap;

    ${({ $selected: t, theme: n }) => !t && e`
            &:hover {
                color: ${n.colors.foreground};
            }
        `}

    &:focus-visible {
        outline: 2px solid ${({ theme: e }) => e.colors.ring};
        outline-offset: -2px;
    }
`, s = t.span`
    display: inline-flex;
    width: ${({ $size: e }) => e}px;
    height: ${({ $size: e }) => e}px;
    color: inherit;
`;
//#endregion
export { o as Segment, s as SegmentIcon, a as Thumb, r as Track };
